import React, { createContext, useState } from 'react';

//create a context, with createContext api
export const MapContext = createContext();

const MapContextProvider = (props) => {
        // this state will be shared with all components 
    const [currentProduct, setCurrentProduct] = useState(0);

    return (
                // this is the provider providing state
        <MapContext.Provider value={[currentProduct, setCurrentProduct]}>
            {props.children}
        </MapContext.Provider>
    );
};

export default MapContextProvider;